// USA
export const locale = {
  lang: "en",
  data: {
    TRANSLATOR: {
      SELECT: "Select your language",
    },
    MENU: {
      MEETINGS: "MEETINGS",
      CARS: "Cars",
      ADMINISTRADOR: "ADMINISTRADOR",
      SPACE: "Spaces",
      NEW: "New",
      ACTIONS: "Actions",
      CREATE_POST: "Create New Post",
      PAGES: "Pages",
      FEATURES: "Features",
      APPS: "Apps",
      DASHBOARD: "Dashboard",
      CALENDAR: "Calendar",
      ROOMS: "Rooms",
      REPORT: "Report Faults",
      USERSETTINGS: "User Settings",
      SYSTEMSETTINGS: "System Settings",
      LOGOCONFIGURATION: "Logo Configuration",
      EMAILCONFIGURATION: "Email Configuration",
      EQUIPMENTS: "Equipments",
      STYLESETTINGS: "Style Settings",
      CONFIGURATIONBYLOCATION: "Configuration by Location",
      ROOMSETTINGS: "Resources Settings",
      ACCOUNTINFORMATION: "Account Information",
      BOOKING: "Booking",
      CHECKOUTS: "Checkouts",
      NOCHECKOUTS:"No Check-Out",
      VISITORS: "Visitors",
      VISITS: "Visits",
      CONFIGURECUSTOMERADMIN: "Configure Customer Admin",
      MRROOM: "MrRoom",
      ADMMINBACKOFFICE: "Admin Back Office",
      ADMIN: "Admin",
      MRVISITS: "MrVisits",
      USERS: "Users",
      ROLLSETTINGS: "Role Settings",
      ACCESSRIGHTS: "Access Rights",
      VisitsSettings: "Visitor Settings",
      ORDERS: "Orders",
      ORDERPENDING:"Orders Pending",
      VISITORVISIT : "Visitor/Visit",
      LICENSEDASHBOARD: 'License Dashboard'
    },
    ROOMS: {
      PLANT: "Space",
      MAPPLANT: "Space",
      SUNDAY: "Sun",
      MONDAY: "Mon",
      TUESDAY: "Tue",
      WEDNESDAY: "Wed",
      THURSDAY: "Thu",
      FRIDAY: "Fri",
      SATURDAY: "Sat",
      LOCATION: "Location",
      ROOMS: "Rooms",

      EQUIPMENTS: "Equipments",
      STARTDATE: "Start Date",
      ENDDATE: "End Date",
      STARTTIME: "Start Time",
      ENDTIME: "End Time",
      TIMEDURATION: "Time Duration",
      ALL: "All",
      MEETINGROOM: "Meeting Room",
      DESK: "Desk",
      CAR: "Car",
      SERVICE: "Service",
      BOOK: "Book",
      SERVICES: "Services",
      CATERING: "Catering",
      ITSUPPORT: "IT Support",
      MOBILEEQUIPMENT: "Mobile Equipment",
      SPECIAL: "Special",
      COMMINGSOON: "Coming Soon",
      ROOMBOOKING: "Room Booking",
      LOCATIONS: "Location",
      RESOURCES: "Resource",
      REQUESTERNAME: "Requester Name",
      SUBJECT: "Subject",
      DESCRIPTION: "Description",
      ADDUSER: "Add User",
      ADDVISITORS: "Add Visitors",
      EDITVISITORS: "Edit Visitors",
      CATERINGDESCRIPTION: "Catering Description",
      MOBILEEQUIPMENTDESCRIPTION: "Mobile Equipment Description",
      ITSUPPORTDESCRIPTION: "IT Support Description",
      SPECIALSERVICE: "Special Service",
      SPECIALSERVICEDESCRIPTION: "Special Service Description ",
      REQUESTEREMAIL: "Requester Email",
      NOSERVICE: "Services not available!",
      SUMMARY: "Summary",

      TOTALBOOKINGS: "Total Bookings",
      TOTALMINUTES: "Total Minutes",
      USERS: "Users",
      AVERAGEBOOKINGSTIMES: "Average Booking Time",
      ROOM: "Room",
      DESKS: "Desk",
      CARS: "Car",
      PARKINGSEATS: "Parking Seats",
      AVILABLE: "Available",
      FULL: "Full",
      ROOMUSAGE: "Room Usage",
      CARUSAGE: "Car Usage",
      DESKUSAGE: "Desk Usage",
      NUMBEROFBOOKINGSPERROOM: "Number of Bookings per Room",
      NUMBEROFMINTUESPERROOM: "Number of minutes per Room",
      NUMBEROFMINTUESPERDESK: "Number of minutes per Room",
      NUMBEROFBOOKINGPERDESK: "Number of Bookings per Desk",
      PARKINGSPACEUSAGE: "Parking Seats Usage",
      USER: "User",
      NUMBEROFBOOKINGSPERPARKINGSEATS: "Number of Bookings per Parking Seat",
      NAME: "Name",
      BOOKINGS: "Bookings",
      MINTUES: "Minutes",
      ATTENDED: "Attended",
      CANCEL: "Cancel",
      NUMBEROFMINTESPERPARKINGSEATS: "Number of Minutes per Parking Seat",
      CHECKIN: "Check-In",
      TYPEOFBOOKING: "Type of Bookings",
      MEETINGBEHAVIOR: "Meeting Behavior",
      USERTHATMISSEDCHECKIN: "Users that missed check-in",
      ENDEDASPLANING: "Ended as Planing",
      ENDEDONLY: "Ended Early",
      CANCELED: "Canceled",
      TOTAL: "Total",
      ACTIVE: "Active",
    },
    ROOMBOOKING: {
      EXTENDTIMEDURATION: "Extend Time Duration",
      MINUTE: "Minute",
      PINCODE: "PIN Code",
      NEWBOOKING: "New booking",
      LOCATIONS: "Location",
      BUILDING: "Building",
      FLOOR: "Floor",
      RESOURCES: "Resource",
      STARTDATE: "Start Date",
      ENDDATE: "End Date ",
      STARTTIME: "Start Time",
      ENDTIME: "End Time",
      TIMEDURATION: "Time Duration",
      SELECTLOCATION: "Select Your Location",
      SELECTBUILDING: "Select Your Building",
      SELECTFLOOR: "Select Your Floor",
      SELCETRESOURCE: "Select your Resources",
      SELECTTIMEDURATION: "Select Time Duration",
      TIMEDURATIONREQUIRED: "Time Duration is required",
      SELECTYOURROOM: "Select your Meeting Room",
      SELECTYOURDESK: "Select your Desk",
      SELECTCAR: "Select Your Car",

      COMPANY: "Company",
      VISITORNAME: "Visitor Name",

      DRIVER: "Driver ",
      LICENSEPLATE: "Plate",
      USAGETYPE: "Usage Type",

      CARREQUIRED: "Car is required",
      ROOMREQUIRED: "Meeting room is required",
      CHARGINGCARREQUIRED: "Charging Car is required",
      PARKINGSEATREQUIRED: "Parking seat is required",

      DESKREQUIRED: " Desk is required",
      RESOURCETYPEREQUIRED: "Resource Type is Required",
      REQUESTOREMAILREQUIRED: "Requester email is required",
      REQUESTORNAMEREQUIRED: "Requester Name is required",
      DESKS: "Desks",
      REQUESTORNAME: "Requester Name",
      REQUESTOREMAIL: "Requester Email",
      SUBJECT: "Subject",
      BOOK: "Book",
      CAR: "Car",
      CARS: "Cars",
      SUBJECTISREQUIRED: "Subject is required",
      ADDUSERS: "Add Users",
      ADDUSER: "Add User",
      ADDVISITORS: "Add Visitors",
      PARKINGSEATS: "Parking Seats",
      CATERRING: "Catering",
      MOBILEEQUIPMENT: "Mobile Equipments",
      ITSUPPORT: "IT Support",
      CATERINGDESCRIPTION: "Catering Description",
      MOBILEEQUIPMENTDESCRIPTION: "Mobile Equipment Description",
      ITSUPPORTDESCRIPTION: "IT Support Description",
      SPECIALSERVICE: "Special Service",
      SPECIALSERVICEDESCRIPTION: "Special Service Description ",
      CLOSE: "Close",
      BACK: "Back",
      EQUIPMENT: "Equipment",
      STARTDATEISREQUIRED: "Start Date is Required",
      ENDDATEISREQUIRED: "End Date is Required",
      STARTTIMEISREQUIRED: "Start Time is Required",
      ENDTIMEISREQUIRED: "End Time is Required",
      ROOMS: "Rooms",
      DESCRIPTION: "Description",
      QUANTITY: "Quantity",
      CLEANING: "Cleaning",
      CLEANINGDESCRIPTION: "Cleaning Description",
      CHECKROOMAVAILABLITY: "Check Room Availablity",
      EDITBOOKING: "Edit Booking",
      EDIT: "Edit",
      DELETE: "Delete",
      CANCEL: "Cancel",
      EXTEND: "Extend",
      END: "End",
      VIEWBOOKING: "View Booking",
      BOOKINGID: "Booking ID",
      USERS: "Users",
      VISITORS: "Visitors",
      ALLDAY: "All Day",
      CAPACITY: "Capacity",

      EMPLOYEE: "Employee",
      VISIT: "Visit",
      CLIENT: "Client",
      SUPPLIER: "Supplier",
      COWORKER: "Co-Worker",
      CHECKOUT: "Checkout",
      DEBIT: "Debit",
      YES: "Yes",
      NO: "No",
      CHARGINGCAR: "Charging Car",
      CHARGINGCARS: "Charging Cars",
      CHARGINGCARUSAGE: "Charging Car Usage",
      CHARGINGCARDURATION: "Charging Car Duration:",
      QUANTITYISREQUIRED: "Quantity is required",

      INVALIDSTARTTIME: "Invalid Start Time",
      INVALIDENDTIME: "Invalid End Time",
      AREYOUSUREYOUWANTTOACTIVATE: "Are you sure, You want to activate?",
      AREYOUSUREYOUWANTTODEACTIVATE: "Are you sure, You want to deactivate?",
      AREYOUSURE: "Are you sure?",
      AREYOUSUREYOUWANTTODELETE: "Are you sure, You want to delete?",
      ALLOWBOOKING: "Are you sure, You want to allow the booking?",
      DENYBOOKING: "Are you sure, You want to deny the booking?",
      CREATEVISITOR: "Create Visitor",
      ORDERMOBILEEQUIPMENT: "Would you like to order"
    },
    DASHBOARD: {
      FROM: "From",
      TO: "To",
      NOWINUSE: "Now",
      FREEROOMS: "Free Rooms",
      FREEDESKS: "Free Desks",
      FREEPARKINGSEATS: "Free Parking Seats",
      TODAY: "Today",
      RESERVATIONSOFROOMS: "Reservations Of Rooms",
      RESERVATIONSOFDESKS: "Reservations Of Desks",
      RESERVATIONSOFPARKINGSEATS: "Reservations Of Parking Seats",
      USERSMISSEDCHECKIN: "Users Missed Check In",
      NORECENTCHECKIN: "No Recent Check In",
      CURRENTMONTH: "Current Month",
      RESERVATIONSPERROOM: "Reservations per Rooms",
      RESERVATIONSPERDESK: "Reservations per Desk",
      PARKINGSEATSRESERVATIONS: "Parking Seats Reservations",
      RESERVATIONSPERUSER: "Reservations per User",
      MISSINGRESERVATIONS: "Missing Reservations",
      TIMEOFRESERVATIONSPERUSER: "Time Of Reservations per User",
      TIMEOFRESERVATIONSPERROOM: "Time Of Reservations per Room",
      TIMEOFRESERVATIONSPERDESK: "Time Of Reservations per Desk",
      TOTALCOSTPERUSER: "Total Cost per User",
      DOWNLOADASCSVFILE: "Download As CSV File",
    },
    USERSETTINGS: {
      UPLOADCSV: "Upload CSV",
      IMPORTFROMLDAP: "Import From LDAP",
      AZUREACTIVEDIRECTORY: "Azure Active Directory",
      EDIT: "Edit",
      DELETE: "Delete",
      BUILDINGSETTINGS: "Building Settings",
      SSO: "SSO",
      ADD: "Add",
      NAME: "Name",
      EMAIL: "Email",
      LOCATION: "Location",
      ROLE: "Role",
      ACTION: "Action",
      FILTER: "Filter",
      CSVFILE: "CSV File",
      DOWNLOADTEMPLATE: "Download Template",
      UPLOAD: "Upload",
      NODATAFOUND: "No Data Found",
      LDAPSERVER: "LDAP Server",
      PORT: "Port",
      DISABLETLS: "Disable TLS",
      IMPORT: "Import",
      CANCEL: "Cancel",
      USERNAME: "Username",
      PASSWORD: "Password",
      CHECKCONNECTION: "Check Connection",
      LDAPSERVERBASE: "LDAP Server Base",
      LDAPSEARCHFILTER: "LDAP Search Filter",
      DEFAULTADUSERMAILBOX: "Default AD User Mailbox Filter",
      CUSTOMLDAPFILTER: "Custom LDAP Filter",
      LDAPRFIDATTRIBUTE: "LDAP RFID Attribute (Optional)",
      COUNTRY: "Country",
      ADDUSER: "Add User",
      EDITUSER: "Edit User",
      DELETEUSER: "Delete User",
      CLOSE: "Close",
      ADDROLES: "Add Roles",
      ROLENAME: "Role Name",
      NAMEISREQUIRED: "Name is required",
      ACCESSRIGHTS: "Access Rights",
      SELECTALL: "Select All",
      SELECTROLE: "-- Select Role --",
      ROLEISREQUIRED: "Role is required",
      EDITUSERROLE: "Edit User Role",
      DELETEUSERROLE: "Delete User Role",
      SAVE: "Save",
      RESOURCERIGHTS: "Resource Rights",
      RESOURCEISREQUIRED: "Resource is required",
      SELECTALLMEETROOM: "Select All Meeting Room",
      SELECTALLDESK: "Select All Desk",
      SELECTALLPARKINGSEATS: "Select All Parking Seats",
      SELECTALLCHARGINGCAR: "Select All Charging Car",
      SELECTALLCAR: "Select All Car",
    },
    USERACCESSRIGHTS: {
      CLOSE: "Close",
      EDITROLES: "Edit Roles",
      BOOKABUILDING: "Book a building",
      BOOKADESK: "Book a desk",
      ORDERCATERING: "Order catering",
      ENDABOOKING: "End a booking",
      ACTIVATEINACTIVATE: "Activate/Inactivate Meeting Rooms",
      PARKINGCHECKOUT: "Parking Check-Out",
      ACTIVATEINACTIVATEDISPLAYS: "Activate/Inactivate Displays",
      BOOKAFLOOR: "Book a floor",
      BOOKAPARKINGSEATS: "Book a parking seat",
      ORDERMOBILEEQUIPMENT: "Order mobile equipments",
      DELETEABOOKING: "Delete a booking",
      ACTIVATEINACTIVATEDESK: "Activate/Inactivate Desks",
      ACTIVATEINATIVATEKIOSKS: "Activate/Inactivate Kiosks",
      ORDERSPECIALSERVICES: "Order special services",
      BOOKAROOM: "Book a room",
      ORDERITSERVICES: "Order IT services",
      EDITABOOKING: "Edit a booking",
      EXTENDABOOKING: "Extend a booking",
      ACTIVATEINACTIVATEPARKINGSEATS: "Activate/Inactivate Parking seats",
      ACTICATEINACTICATEVIEWPOINTS: "Activate/Inactivate View Points",
    },
    LOGOCONFIGURATION: {
      ENABLELOGOCHANGES: "Enable Logo Changes",
      UPLOADLOGO: "Upload Logo",
      URL: "URL",
      OR: "(OR)",
      SAVE: " Save",
    },
    EMAILCONFIGURATION: {
      EMAILCONFIGURATION: "Email Configuration",
      EMAIL: "Email",
      PASSWORD: "Password",
      HOSTSERVER: "Host Server",
      PORT: "Port",
      CHECKEMAIL: "Check Email",
      EMAILISREQUIRED: "Email is required",
      COUNTRYISREQUIRED: "Country is required",
      ENTERYOUREMAIL: "Enter Your Email",
      PASSWORDISREQUIRED: "Password is required",
      ENTERYOURPASSWORD: "Enter Your Password",
      ENTERPORT: "Enter Your Port",
      PORTISREQUIRED: "Port is required",
      ENTERHOSTSERVER: "Enter Host Server",
      HOSTSERVERREQUIRED: "Host  is required",
      SAVE: "Save",
      TOEMAIL: "To Email",
    },
    STYLESETTINGS: {
      SYSTEMSTYLE: "System Style",
      SIDEBUTTONCOLOR: "Side Button Color",
      ACTIONBUTTONCOLOR: "Action Button Color",
      TOPTITLES: "Top Titles",
      TEXTCOLOR: "Text Color",
      BACKGROUNDCOLOR: "Background Color",
      KIOSKCHECKINSTYLE: "Kiosk Check In Style",
      BACKGROUNDIMAGE: "Background Image",
      KIOSKINFORMATION: "Kiosk Information",
      SERVICESVIEWPOINTSDISPLAYINFORMATION:
        "Services View Points Display Information",
      SAVE: "Save",
      CANCEL: "Cancel",
      RESTORETODEFAULT: "Restore To Default",
    },
    CONFIGURATIONBYLOCATION: {
      SEARCHHERE: "Search Here",
      COUNTRY: "Country",
      LOCATION: "Location",
      TIMEZONE: "TimeZone",
      ACTIONS: "Actions",
      ADDRESS: "Address",
      EDITLOCATIONTITLE: "Edit Location",
      LOCATIONSETTINGSTITLE: "Location Settings",
      ADDBUILDINGTITLE: "Building",
    },
    EQUIPMENTS: {
      EQUIPMENTALIGNMENT: "Equipment Alignment",
      SEARCHHERE: "Search Here",
      ICON: "Icon",
      TITLE: "Title",
      ACTION: "Action",
      LEFT: "Left",
      RIGHT: "Right",
      TOP: "Top",
      BOTTOM: "Bottom",
      ADD: "Add",

      EDITEQUIPMENT: "Edit Equipment",
      DELETEQUIPMENT: "Delete Equipment",
      EQUIPMENNAME: "Equipment Name",
      SELECTEQUIPMENTICON: "Select Equipment Icon",
      SAVE: "Save",
      CANCEL: "Cancel",
      REQUIREDFIELD: "Required field",
      ADDNEWEQUIPMENT: "Add New Equipment",
      DELETE: "Delete",
      EMAIL: "Email",
    },
    ACCOUTINFORMATION: {
      COMPANYNAME: "Company Name",
      CONTACTNAME: "Contact Name",
      PHONENUMBER: "Phone Number",
      COUNTRY: "Country",
      RESELLER: "Reseller",
      EMAILTOREGISTRATION: "Email to Registration",
      TYPEOFACCOUNT: "Type of Account",
      NUMBEROFROOMS: "Number of Rooms",
      NUMBEROFROOMSDISPLAYS: "Number of Rooms Displays",
      NUMBEROFDESKS: "Number of Desks",
      NUMBEROFDESKSDISPLAYS: "Number of Desks Displays",
      NUMBEROFPARKINGSPACES: "Number of Parking Seats",
      NUMBEROFSERVICESVIEWPOINTS: "Number of Viewpoints",
      NUMBEROFKIOSKS: "Number of Kiosks",
      NUMBEROFSPACES: "Number of Space",
      NUMBEROFSPACE: "Number of Spaces",
      ACCOUNTID: "Account ID",
      VALIDFROM: "Valid from",
      VALIDTO: "Valid to",
      CONTACTSUPPORT: "Contact Support",
      MESSAGE: "Message",
      CLOSE: "Close",
      SEND: "Send",
    },
    LOGINGPAGE: {
      WELCOMETOMRROOMS: "Welcome to Zelo Meetings",
      NEWHERE: "New Here?",
      DEMOACCOUNT: "Demo Account",
      ENTERYOURDETAILSTOCREATEYOURACCOUNT:
        "Enter Your Details To Create Your Account",
      COMPANYNAME: "Company Name",
      CONTACTNAME: "Contact Name",
      PHONE: "Phone",
      COUNTRY: "Country",
      CONFIRMPASSWORD: "Confirm Password",
      ACCEPTTERMSCONDITIONS: "Accept Terms Conditions",
      TERMSANDCONDITIONS: "Terms And Conditions",
      EMAIL: "Email",
      PASSWORD: "Password",
      FORGOTPASSWORD: "Forgot Password?",
      DISCOVERAMAZINGWORKSPACE: "Discover Amazing Work Space",
      SERVICEVIEWPOINTS: "Viewpoints",
      KIOSKSMAPPLANTS: "Kiosks Map Plants",
      ENTERYOUREMAILTORESETYOURPASSWORD:
        "Enter Your Email To Reset Your Password",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
      SIGNIN: "Sign In",
      EMAILIDISREQUIRED: "Email Id is Required",
      PASSWORDISREQUIRED: "Password is Required",
      INVALIDEMAILID: "Invalid Email",
      THELOGINDETAILSAREINCORRECT: "Login details are incorrect!",
      COMPANYNAMEISREQUIRED: "Company Name Is Required",
      NAMEISREQUIRED: "Name Is Required",
      PHONENUMBERISREQUIRED: "Phone Number Is Required",
      COUNTRYISREQUIRED: "Country Is Required",
      EMAILISREQUIRED: "Email Is Required",
      CONFIRMPASSWORDISREQUIRED: "Confirm Password is Required",
      ACCEPTTSCSISREQUIRED: "Accept TSCS Is Required",
    },
    CALENDAR: {
      TODAY: "Today",
      MEETINGROOMS: "Meeting Rooms",
      DESK: "Desk ",
      PARKINGSEATS: "Parking Seats ",
      MONTH: "Month ",
      WEEK: "Week ",
      DAY: "Day",
      SUNDAY: "Sunday",
      MONDAY: "Monday",
      TUESDAY: "Tuesday",
      WEDNESDAY: "Wednesday",
      THURSDAY: "Thursday",
      FRIDAY: "Friday",
      SATURDAY: "Saturday",
      ALLMEETINGROOMS: "All Meeting Rooms",
      ALLDESK: "All Desk",
      ALLPARKINGSEATS: "All Parking Seats",
      CHARGINGCAR: "Charging Car",
      ALLCHARGINGCAR: "All Charging Car",
      // SELECTBUILDING:'Select Building'
      YOUWANTTOENDTHEBOOKING: "You want to end the Booking!",
    },

    MONTH: {
      JANUARY: "January,",
      FEBRUARY: "February,",
      MARCH: "March,",
      APRIL: "April,",
      MAY: "May,",
      JUNE: "June,",
      JULY: "July,",
      AUGUST: "August,",
      SEPTEMBER: "September,",
      OCTOBER: "October,",
      NOVEMBER: "November,",
      DECEMBER: "December,",
    },

    REPORT: {
      LOCATION: "Location",
      ROOMS: "Rooms",
      SERVICES: "Equipments",
      NOSERVICEDATAAVAILABLE: "No service data available",
      LOCATIONISREQUIRED: "Location is required",
      ROOMSISREQUIRED: "Rooms is required",
      SELECT: "--Select--",
      DAMAGED: "Are you sure, The equipment is damaged?",
      CONFIRM: "Confirm",
      FIX: "Do you want to fix this equipment?",
      OBSERVATION: "Observations",
      OBSERVATIONPLACEHOLDER: "Enter the Observations",
      BUILDING: "Building",
      FLOOR: "Floor",
      SELECTBUILDING: "Select Building",
      SELECTFLOOR: "Select Floor",
    },
    ROOMSETTINGSMATTABLE: {
      NAME: "Name",
      LOCATIONS: "Location",
      FILTER: "Filter",
      ACTION: "Action",
      ADD: "Add",
      MEETINGROOM: "Meeting Rooms",
      DESKS: "Desks",
      PARKINGSEATS: "Parking Seats",
      CHARGINGCAR: "Charging Car",
      KIOSKS: "Kiosks",
      VIEWPOINT: "Viewpoints",
      DISPLAY: "Displays",
      OPENSPACE: "Open Space",
      SPACE: "Spaces",
      FLOORNO: "Floor",
      CAR: "Cars",
      CROP: "Edit Crop",
      EDIT: "Edit Space",
      AVAILABLE: "Available to booking",
      EDITMEETINGROOMTITLE: "Edit Meeting Room",
      EDITDESKTITLE: "Edit Desk",
      EDITPARKINGSEARTITLE: "Edit Parking Seat",
      EDITCHARGINGCARTITLE: "Edit Charging Car",
      DELETECHARGINGCARTITLE: "Delete Charging Car",
      EDITKIOSKTITLE: "Edit Kiosk",
      EDITCARTITLE: "Edit Car",
    },
    ROOMSETTINGSDISPLAYMATTABLE: {
      DISPLAYID: "Display ID",
      SERIALNO: "Serial No",
      TYPES: "Type",
      FILTER: "Filter",
      ROOMS: "Rooms",
      DESKNAME: "Desk Name",
      LOCATIONS: "Location",
      ACTION: "Action",
      DISPLAYNAME: "Display Name",
      ADD: "Add",
      ROOMDESKNAME: "Room/Desk Name",
      EDITDISPLAYTITLE: "Edit Display",
      DELETEDISPLAY: "Delete Display",
    },
    ROOMSETTINGSMEETINGROOMFORM: {
      EDITMEETINGROOM: "Edit Meeting Room",
      NAME: "Name",
      ENTERNAME: "Enter Name",
      EDITCAR: "Edit Car ",
      CAPACITY: "Capacity",
      PARKING: "Parking",
      ENTERPARKING: "Enter Parking",
      KILOMETERS1: "Kilometers :",
      KILOMETERS: "Kilometers",
      ENTERKILOMETERS: "Enter Kilometers",
      FUEL1: "Fuel :",
      FUEL: "Fuel",
      SELECTFUEL: "--Select Fuel--",
      RESERVE: "Reserve",
      TANK1: "1/4 Tank",
      TANK2: "Half Tank",
      TANK3: "3/4 Tank",
      TANK4: "Full Tank",

      NOTES: "Notes",

      ROOMNAMEREQUIRED: "Meeting Room name is required",
      CARNAMEISREQUIRED: "  Car name is required",
      LOCATION: "Location",
      HOURLYPRICE: "Hourly Price",
      FLOOR: "Floor",
      CAPACITY1: "Capacity",
      ENTERFLOOR: "Enter Floor",
      ENTERCAPACITY: "Enter Capacity",
      SELECTDISPLAYNAME: "Select Display Name",
      INTEGRATIONTYPE: "Integration Type",
      RESOURCEMAIL: "Resource Email",
      PASSWORD: "Password",
      ENTERRESOURCEEMAIL: "Enter Resource Email",
      SELECTLOCATION: "--Select Location--",
      DAILYPRICE: "Daily Price",
      WEEKLYPRICE: "Weekly Price",
      MONTHLYPRICE: "Monthly Price",
      CREATEQRCODE: "Create QR Code",
      SUBMIT: "Submit",
      UPDATEDSUCESSFULLY: "Updated Successfully",
      WORKINGDAYS: "Working Days",
      SELECTTYPE: "Select Type",
      STANDARD: "Standard",
      IMAGE: "Image",
      PROVIDERINFORMATION: "Provider Information",
      ENTERPROVIDERINFORMATION: "Enter Provider Information ",
      EQUIPMENTS: "Equipments",
      PREMIUM: "Premium",
      DESCRIPTION: "Description",
      CANCEL: "Cancel",
      DISPLAYNAME: "Display Name",
      BACK: "Back",
      PREMIUMUSER: "Premium User",
      ENTERPASSWORD: "Enter Password",
      ENTERDESCRIPTION: "Enter Description",

      INSURANCECOMPANY: "Insurance Company",
      INSURANCEPOLICY: "Insurance Policy",
      VALIDUNTIL: "Valid until",
      TRAVELASSISTANCECONTACT: "Travel Assistence Contact",
      MODALITY: "Modality",
      PURCHASE: "Purchase",
      RENTING: "Renting",
      UNTIL: "Until",
      MAINTENANCE: "Maintenance",

      NAME1: "Name :",
      DESCRIPTION1: "Description :",
      LASTMAINTENANCE1: "Last Maintenance :",
      DOWNLOADCSVFILE: "Download CSV File",
      CLOSE: "Close",
      SAVECHANGES: "Save Changes",

      LASTMAINTENANCE: "Last Maintenance",
      CONFIGURE: "Plant Configure",
      PREMIUMUSERPLACHOLDER: "Select Premium Users",
      CREATEDSUCCESSFULLY:"Created Successfully",
    },
    ROOMSETTINGSDESKFORM: {
      EDITDESK: "Edit Desk",
      NAME: "Name",
      DESKNAMEREQUIRED: " Desk name is required",
      LOCATION: "Location",
      HOURLYPRICE: "Hourly Price",
      FLOOR: "Floor",
      INTEGRATIONTYPE: "Integration Type",
      DAILYPRICE: "Daily Price",
      WEEKLYPRICE: "Weekly Price",
      MONTHLYPRICE: "Monthly Price",
      CREATEQRCODE: "Create QR Code",
      SUBMIT: "Submit",
      UPDATEDSUCESSFULLY: "Updated Successfully",
      WORKINGDAYS: "Working Days",
      SELECTEDTYPE: "Select Type",
      STANDARD: "Standard",
      IMAGE: "Image",
      EQUIPMENTS: "Equipments",
      PREMIUM: "Premium",
      DESCRIPTION: "Description",
      CANCEL: "Cancel",
      OPENSPACENAME: "Open Space Name",
      SELECTOPENSPACE: "--Select Open Space Name--",
      BACK: "Back",
      MAXIMUMSEATS: "Maximum Seats",
      DISPLAYNAME: "Display Name",
      PREMIUMUSER: "Premium User",
    },
    ROOMSETTINGSOPENSPACEMATTABLE: {
      OPENSPACENAME: "Open Space Name",
      FLOOR: "Floor",
      ACTIVEDESKS: "Active Desks",
      TOTALDESKS: "Total Desks",
      ACTION: "Action",
      ADD: "Add",
    },
    OPENSPACEADDMODAL: {
      ADDOPENSPACE: "Add Open Space",
      EDITOPENSPACE: "Edit Open Space",
      OPENSPACENAME: "Open Space Name",
      ENTEROPENSPACENAME: "Enter Open Space Name",
      OPENSPACENAMEREQUIRED: " Open Space Name is required",
      FLOOR: "Floor",
      TOTALCAPACITY: "Total Capacity",
      ENTERTOTALCAPACITY: "Enter Total Capacity",
      PANDEMICSITUATION: "Pandemic Situation",
      BOOKINGCAPACITY: "Booking Capacity",
      CLOSE: "Close",
      SAVE: "Save",
      UPDATE: "Update",
    },
    ROOMSETTINGSPARKINGSEATFORM: {
      EDITCHARGINGCAR: "Edit Charging Car",
      CHARGINGCAR: "Charging Car",
      EDITPARKINGSEAT: "Edit Parking Seat",
      PARKINGSEATNUMBER: "Parking Seat Number",
      ENTERPARKINGSEAT: "Enter Parking Seat Number",
      PARKINGSEATNUMBERISREQUIRED: "Parking Seat Number is required",
      FLOOR: "Floor",
      USERMOBILENUMBER: "User Contact Number",
      ENTERMOBILENUMBER: "Enter Contact Number",
      ENTEREMAIL: "Enter Email",
      CARBRAND: "Car Brand",
      ENTERCARBRAND: "Enter Car Brand",
      PLATE: "Plate",
      ENTERPLATE: "Enter Plate",
      MODEL: "Model",
      ENTERMODEL: "Enter Model",
      PERMANENT: "Permanent",
      LOCATION: "Location",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
      FROM: "Available from",
      TO: "to",
      BACK: "Back",
      USEREMAIL: "User Email",
    },
    ROOMSETTINGSKIOSKFORM: {
      EDITKIOSK: "Edit Kiosk",
      NAME: "Name",
      ENTERKIOSKNAME: "Enter Kiosk Name",
      KIOSKNAMEISREQUIRED: "Kiosk name is required",
      LOCATION: "Location",
      FLOOR: "Floor",
      ROOM: "Room",
      DESK: "Desk",
      LOGOUPLOADFILE: "Logo Upload File",
      CREATEQRCODE: "Create QR Code",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
      BACK: "Back",
      DESKERRORMSG: "Atleast one desk is required",
      ROOMERRORMSG: "Atleast one Room is required",
      SERVICEERRORMSG: "Atleast one Service is required",
    },
    ROOMSETTINGVIEWPOINTSFORM: {
      EDIDVIEWPOINTS: "Edit View Points",
      NAME: "Name",
      ENTERVIEWPOINTSNAME: "Enter View Points Name",
      VIEWPOINTSNAMEISREQUIRED: "  View Points Name is required",
      LOCATION: "Location",
      LOGOUPLOADFILE: "Logo Upload File",
      SUBMIT: "Submit",
      CANCEL: "Cancel",
      BACK: "Back",
      SERVICES: "Services",
    },
    DISPLAYMODALFORM: {
      ADDDISPLAY: "Add Display",
      EDITDISPLAY: "Edit Display",
      DISPLAYID: "Display ID",
      DISPLAYIDISREQUIRED: "Display Id is required",
      SERIALNO: "Serial No",
      SELECTMEETINGROOM: "--Select Meeting Room--",
      SELECTPARKINGSEAT: "--Select Parking Seat--",
      SELECTCHARGINGCAR: "--Select Charging Car--",
      SELECTDESK: "--Select Desk--",
      OS: "OS",
      TYPES: "Type",
      ROOMNAME: "Room Name",
      PARKINGSEATNAME: "ParkingSeat Name",

      LOCATION: "Location",
      DESKNAME: "Desk Name",
      DESK: "Desk",
      MEETINGROOM: "Meeting Room",
      PARKINGSEAT: "Parking Seat",
      SAVE: "Save",
      ADD: "Add",
      CHARGINGCAR: "Charging Car",
      VISITKIOSK: "Visit Kiosk",
      IMAGE: "Image",
    },
    LOCATIONCONFIGURATION: {
      ADDNEWLOCATION: "Add new Location",
      UPDATELOCATION: "Update Location",
      SELECTCOUNTRY: "Select Country",
      ENTERLOCATION: "Enter Location",
      SELECTTIMEZONE: "Select Time Zone",
      CHECKOUT: "Send email after check-out",
      ADDRESS: "Address",
      ALL: "All",
      SAVE: "Save",
      DELETE: "Delete",
      CANCEL: "Cancel",
      OR: "(or)",
      LOCATIONCONFIGURATION: "Location Configuration",
      LOGOCONFIGURATION: "Logo Configuration",
      ENABLELOGOCHANGES: "Enable Logo Changes",
      UPLOADLOGO: "Upload logo",
      URL: "URL",
      REPORTING: "Reporting",
      EMAIL: "Email",
      MEETINGROOM: "Meeting Rooms",
      DESK: "Desks",
      DISPLAYCHECKIN: "Display Check In",
      GENERATEPINCODE: "Generate PIN Code",
      BOOKONDISPLAY: "Book on Display",
      NETWORKONDISPLAY: "Observations",
      SELECTTIME: "Select Time",
      SELECTPREMIUMUSER: "Select Premium Users",
      PARKINGSEATS: "Parking Seats",
      CARS: "Cars",
      PREMIUM: "Premium",
      PARKINGSEATSEMAILS: "Parking Seats Emails",
      CAREMAILS: "Car Emails",
      LABOURHOURS: "Labour Hours",
      SELECTFROMTIME: "Select from time",
      HOUR: "Hour",
      SELECTENDTIME: "Select end time",
      CLEANING: "Cleaning",
      CLEANINGTIME: "Cleaning Time",
      CLEANINGEMAILS: "Cleaning emails",
      MOBILEEQUIPMENT: "Mobile Equipment",
      MOBILEEQUIPMENTNAME: "Mobile Equipment Name",
      EMAILS: "Emails",
      ACTION: "Action",
      SEARCHHERE: "Search here",
      CATERING: "Catering",
      CATERINGNAME: "Catering Name",
      ITSUPPORTSERVICE: "IT Support",
      SPECIALSERVICES: "Special Services",
      ADDSPECIALSERVICE: "Special Services",
      ADD: "Add",
      ADDNEWMOBILEEQUIPMENT: "Add New Mobile Equipment",
      EDITMOBILEEQUIPMENT: "Edit Mobile Equipment",
      DELETEMOBILEEQUIPMENT: "Delete Mobile Equipment",
      MOBILEEQUIPMENTEMAIL: "Mobile Equipment Email *",
      ADDNEWCATERING: "Add Catering",
      CATERINGEMAILS: "Catering Emails *",
      EDITCATERING: "Edit Catering",
      DELETECATERING: "Delete Catering",
      ADDNEWITSUPPORT: "Add IT Support",
      ITSUPPORTNAME: "IT Support Name",
      ITSUPPORTEMAILS: "IT Support Emails *",
      EDITSPECIALSERVICE: "Edit Special Service ",
      DELETESPECIALSERVICE: "Delete Special Services",
      SPECIALSERVICENAME: "Special Service Name",
      SPECIALSERVICEEMAIL: "Special Service Email ",
      ADDNEWSPECIALSERVICE: "Add New Special Service",
      ADDSPECIALSSERVICEEMAILS: "Add Specials Service Emails *",
      NAME: "Name",
      PASSWORD: "Password",
      BACK: "Back",
      ADDNEWLANGUAGE: "Add New Language",
      LANGUAGE: "Language",
      EDIT: "Edit",
      UPDATELANGUAGE: "Update Language",
      EDITITSUPPORTSERVICE: "Edit IT Support Service",
      DELETEITSUPPORTSERVICE: "Delete IT Support Service",
      INFORMREQUESTERABOUTSTART: "Inform requester about start",
      INFORMREQUESTERABOUTEND: "Inform requester about end",
      EQUIPMENT: "Equipment",
      CATERINGBOOKINGRESTRICT: "Restrict Catering Booking within 24 hours",
      SPECIALSERVICEGBOOKINGRESTRICT:
        "Restrict Special Service Booking within 24 hours",
      ITSUPPORTRESTRICT: "Restrict IT Support Booking within 24 hours",
      MOBILEEQUIPMENTRESTRICT:
        "Restrict Mobile Equipment Booking within 24 hours",
      ENDBOOKINGEMAILTIME: "End Booking Email Time",
      HOURS: "Hours",
      ENDONDISPLAY: "End on Display",
      EXTENDONDISPLAY: "Extend on Display",
      BUILDING: "Building",
      BUILDINGNAME: "Building Name",
      BUILDINGNAMEREQUIIRED: "Building Name is required",
      ADDBUILDING: "Add Building",
      EDITBUILDING: "Edit Building",
      DELETEMSG: "Are you sure, You want to permanently delete?",
      FLOOR: "Floor",
      FLOORNAME: "Floor Name",
      FLOORNAMEREQUIRED: "Floor Name is required",
      ADDFLOOR: "Add Floor",
      EDITFLOOR: "Edit Floor",
      BUILDINGCONFIGURATION: "Building Configuration",
      CHARGINGCAREMAIL: "Charging Car Emails",
      CHARGINGCARSETTING: "Charging Car Settings:",
      NORMALCHECKIN: "Normal Check In"
    },
    ADDCONFIGUREADMIN: {
      COMPANYNAME: "Company Name",
      SPACE: "Space",
      ENTERCOMPANYNAME: "Enter Company Name",
      COMPANYNAMEISREQUIRED: "Company name is required",
      TENANTIDQUIRED: "Tenant ID is required ",
      CONTACTNAME: "Contact Name",
      ENTERCONTACTNAME: "Enter Contact Name",
      CONTACTNAMEISREQUIRED: "Contact Name is required",
      PHONENUMBER: "Phone Number",
      ENTERPHONENUMBER: "Enter Phone Number",
      COUNTRYISREQUIRED: "Country is required",
      RESELLER: "Reseller",
      ENTERRESELLER: "Enter Reseller",
      ZELOCAR: "Zelo Cars",
      ZELOSPACES: "Zelo Spaces",

      ZELOSPACES1: "Laia Spaces",
      ZELOCAR1: "Laia Cars",

      COUNTRY: "Country",

      EMAILTOREGISTRATION: "Email to registration",
      ENTEREMAILTOREGISTER: "Enter  Email to registration",

      TYPEOFACCOUNT: "Type of account",
      TYPEOFACCOUNTISREQUIRED: "Account type is required",
      NUMBEROFROOMS: "Number of rooms",
      ENTERNOOFROOMS: "Enter number of Rooms",
      NUMBEROFROOMSDISPLAYS: "Number of rooms displays",
      ENTERNUMBEROFROOMSDISPLAYS: "Enter number of Rooms Displays",
      NUMBEROFDESKS: "Number of Desks",
      NUMBEROFSPACES: "Number of Spaces",

      NUMBEROFDESKSDISPLAYS: "Number of desks displays",

      NUMBEROFPARKINGSPACES: "Number of parking spaces",
      NUMBEROFSERVICESVIEWPOINTS: "Number of services Viewpoints",
      NUMBEROFKIOSKS: "Number of Kiosks",
      ACCOUNTID: "Account ID",
      VALIDFROM: "Valid from",
      VALIDFROMISREQUIRED: " Valid From is required",
      VALIDTO: "Valid to",
      VALIDTOISREQUIRED: "Valid To is required",
      CONTACTSUPPORT: "Contact Support",
      MESSAGE: "Message",
      BACK: "Back",
      SAVE: "Save",
      CANCEL: "Cancel",

      PASSWORD: "Password",
      ONLINEPAYMENT: "Online-Payment",
      MRCARS: "MrCars",
      MRVISITS: "MrVisits",
      ADDCONFIGURECUSTOMERADMIN: "Add Configure Customer Admin",
      EDITCONFIGURECUSTOMERADMIN: "Edit Configure Customer Admin",
      NUMBEROFCARS: "Number Of Cars",
      TENANTID: "Tenant ID",
    },
    DASHBOARDS: {
      FROM: "From",
      TO: "To",
      DOWNLOADCSVFILE: "Download CSV File",
      DOWNLOAD: "Download",
      CUSTOMERADMINS: "Customer Admins",
      ACTIVE: "Active",
      DEMOTRIALACTIVE: "Demo / Trial (active)",
      NEW: "New",
      SHOWMORE: "Show more",
      LEAVING: "Leaving",
      NUMBEROFROOMS: "Number of Rooms",
      NUMBEROFDISPLAYS: "Number of Displays",
      NUMBEROFDESKS: "Number of Desks",
      NUMBEROFDESKSDISPLAYS: "Number of Desks Displays	",
      NUMBEROFPARKINGSEATS: "Number of Parking Seats	",
      NUMBEROFKIOSKS: "Number of Kiosks	",
      NUMBEROFSERVICESVIEWPOINTS: "Number of Services ViewPoints	",
      NUMBEROFONLINEPAYMENT: "Number of On-Line Payment",
      BOOKINGS: "Bookings",
      NUMBEROFBOOKINGSDAY: "Number of Bookings / DAY",
      NUMBEROFBOOKINGSMONTH: "Number of Bookings / Month",
      NUMBEROFBOOKINGYEAR: "Number of Booking / Year",
      UPCOMINGRENEWAL: "Upcoming Renewal",
      NOUPCOMINGRENEWAL: "No Upcoming Renewal",
      RECENTACTIVITIES: "Recent Activities",
      NORECENTACTIVITIES: "No Recent Activities",
    },
    CONFIGURECUSTOMERADMIN: {
      COMPANYNAME: "Company Name",
      EMAIL: "Email",
      COUNTRY: "Country",
      ACCOUNTTYPE: "Account Type",
      VALIDTODATE: "Valid To Date",
      ACTION: "Action",
      ADD: "Add",
    },
    MYPROFILE: {
      MYPROFILE: "My Profile",
      CHANGEPASSWORD: "Change Password",
      CURRENTPASSWORD: "Current Password",
      NEWPASSWORD: "New Password",
      VERIFYPASSWORD: "Verify Password",
      CONFIRMPASSWORD: "Confirm Password",
      SAVECHANGES: "Save Changes",
      SIGNOUT: "Sign out",
      BACK: "Back",
      CANCEL: "Cancel",
      NAME: "Name",
      EMAIL: "Email",
      COUNTRY: "Country",
      LOCATION: "Locations",
      SAVE: "Save",
      BUILDING: "Building",
      FLOOR: "Floor",
      LANGUAGE: "Language"
    },
    ENDUSERDASHBOARD: {
      ROOMS: "Rooms",
      DESKS: "Desks",
      PARKINGSEATS: "Parking Seats",
      ROOMDESKBOOKINGREQUESTS: "Booking requests",
      TYPE: "Type",
      RESOURCE: "Resource",
      REQUESTERNAME: "Requester Name	",
      STARTTIME: "Start Time",
      ENDTIME: "End Time	",
      ACTION: "Action",
      NODATAFOUND: "No data found!",
      CARS: "Cars",
    },
    SIDENAVBAR: {
      MYPROFILE: "My Profile",
      CHANGEPASSWORD: "Change Password",
      CURRENTPASSWORD: "Current Password",
      NEWPASSWORD: "New Password",
      VERIFYPASSWORD: "Verify Password",
      CONFIRMPASSWORD: "Confirm Password",
      SAVECHANGES: "Save Changes",
      SIGNOUT: "Sign out",
      USERPROFILE: "User Profile",
      HI: "Hi,",
    },

    SERVICEVIEWPOINTS: {
      SERVICEVIEWPOINTS: "Service Viewpoints",
      NAME: "Name",
      LOCATION: "Loctions",
      ACTION: "Action",
      FILTER: "Filter",
      BACK: "Back",
    },
    SPACESERVICE: {
      SPACESERVICEADD: "Add Space",
      NAME: "Name",
      ADDRESS: "Address",
      LOCATION: "Location",
      BUILDINGNAME: "Building name",
      FLOORNO: "Floor No",
      IMAGE: "Image",
      BACK: "Back",
      SAVE: "Save",
      CANCEL: "Cancel",
      ACTION: "Action",
      NO: "No.",
    },
    SPACE: {
      SPACELIST: "Select Space",
      SELECTSPACE: "--Select Space--",
      STATUS: "Next Events",
    },
    // Space Edit Crop add function
    CROPSERVICE: {
      CONFIGURERESOURCE: "Configure Resource",
      AREANAME: "Area Name",
      RESOURCETYPE: "Resoure type",
      RESOURCE: "Resource",
      SAVE: "Save",
      CANCEL: "Cancel",
      CROP: "Crop",
      DELETE: "Delete",
      ZOOM: "Zoom",
      BACK: "Back",
    },
    COMMON: {
      AREYOUSURE: "Are you sure?",
      SHOWMORE: "Show  More",
      SHOWLESS: "Show Less",
      YOUWANTTODELETE: "You want to delete!"
    },
    VISITSETTING: {
      VISITSSETTINGS: "Visits Settings",
      VISITORS: "Visitors",
      SAVE: "Save",
      VISITS: "Visits",
      MANDATORYFIELDS: "Mandatory Fields",
      RGPDSAFETYRULES: "RGPD & Safety Rules",
      ENABLERGPDANDSAFETYRULES: "Enable RGPD and Safety Rules",
      RGPDCONDTION: "RGPD Condition",
      SAFETYRULES: "Safety Rules",
      CARDS: "Cards",
      ENABLECARD: "Enable Card ",
      ADDCARD: "Add Card",
      CARDNO: "Card No",
      CARDNUMBER: "Card Number",
      ADDCARDNUMBER:"Add Card Number",
      ACTION: "Action",
      CLOSE: "Close",
      UPDATECARD: "Update Card",
      CARD: "Card",
      DELETECARD: "Delete Card",
      CHECKINCOUNT: "Check-In Count",
      PARTIALCHECKOUTCOUNT:"Partial Check-Out Count",
      ADDVISIT: "Add Visit",
      EDITVISIT:"Edit Visit",
      SELECTDATE: "Select Date",
      DATE:"Date",
      FILTER: "Filter",
      ADDORDER:"Add Order",
      AREYOUSURETOREMOVECARD:"Are you sure to remove card?",
      IACCEPTEDTHECONDITION:"I accept the condition",
      IACCEPTEDTHERULE:"I accept the rules",
      DELETEPERSONALDATA:"Delete personal data",
      DOYOUCONFIRM:"Confirm here if you want to remove your data from our database.",
      VISITOR: {
        NAME: "Name",
        GROUP: "Group",
        COMPANY: "Company",
        DEPTFUNCTION: "Dept/Function",
        EMAIL: "Email",
        CONTACT: "Contact",
        FOODRESTRICTIONS: "Food Restrictions",
        REMOVERGPDDATA: "Remove RGPD Data",
        OBSERVATION: "Observations",
        PLACEHOLDER:{
          ENTERNAME:"Enter Name",
          SELECT:"Select",
          INTEERNAL:"Internal",
          EXTERNAL:"External",
          ENTERCOMPANY :"Enter Company",
          ENTERDEPTFUNCTION:"Enter Dept/Function",
          ENTEREMAIL:"Enter Email",
          ENTERCONTACT:"Enter Contact",
          ENTERFOODRESTICTIONS:"Enter Food Restrictions",
          ENTEROBSERVATION :"Enter Observations",
        },
        REQUIRED:{
          NAMEISREQUIRED:"Name is required",
          GROUPISREQUIRED:"Group is required",
          COMPANYISREQUIRED:"Company is required",
          DEPTFUNCTIONISREQUIRED:"Dept/Function is required",
          EmailIDISREQUIRED:"Email is required",
          INVALIDEMAILID:" Invalid Email id",
          EMAILIDTOLONG:"Email id should contain more than 1 less than 254 characters",
          CONTACTISREQUIRED:"Contact is required",
          FOODISREQUIRED:"Food Restrictions is required",
          OBSERVATIONISREQUIRED:"Observations is required",
        }
      },
      VISIT: {
        LOCATION: "Location",
        BUILDING: "Building",
        PURPOSE: "Purpose",
        HOST: "Host",
        HOSTEMAIL: "Host Email",
        ARRIVAL: "Arrival",
        DEPARTURE: "Departure",
        USERS : "Users",
        HOTELNAME: "Hotel Name",
        RESERVATIONNO: "Reservation no",
        OBSERVATION: "Observations",
        FLIGHTNO: "Flight no",
        FLIGHT:"Flights",
        CHECKIN: "Check-In",
        CHECKOUT: "Check-Out",
        ASSIGNCARD: "Assign Card",
        REMOVECARD: "Remove Card",
        VISITINFO:"Visitor information",
        HOTEL:"Hotel",
        ADDVISITOR:"Add Visitor",
        EDITVISITOR:"Edit Visitor",
        VIEWCHECKINCHECKOUT:"View Check-In & Check-Out",
        STATUS:"Status",
        PARTIALCHECKIN: "Partial Check-In",
        PARTIALCHECKOUT: "Partial Check-Out",
        PLACEHOLDER:{
          ADDVISITOR:"Add Visitors",
          SELECTALL:"Select All",
          SEARCH:"Search",
          SELECTLOCATION:"Select Location",
          LOCATIONISREQUIRED:"Location is required",
          SELECTBUILDING :"Select Building",
          SELECTPURPOSE:"Select Purpose",
          ENTERHOSTEAIL:"Enter Host Email", 
        },
       

      },
      

      ORDER:{
        NAME: "Name",
        VOLUMNSANDPACKAGES:"Volumns/Packages",
        CARRIER:"Carrier",
        NOTE:"Note",
        COLLECTED:"Collected",
        COLLECT:"Collect",
        COLLECTEDNOTES:"Collected Notes",
        ORDERCOLLECTED:"Order collected",
        NOTES: "Notes",
        ENTERYOURNOTES:"Enter your notes:",
        TYPE:"Type your note here… ",   
        DOYOUWANTTOADDNOTES:"Do you want to add any notes?",
        PLACEHOLDER:{
          SELECT:"Select",
          SEARCH:"Search",
          USERISREQUIRED:"User is Required",
          ENTERVOLUMNSPACKAGES:"Enter Volumns/Packages",
          VOLUMNPACKAGESREQUIRED:"Volumns/Packages is required",
          ENTERNOTE:"Enter Note",
        }     
      }




    }
  },


};
